var _style, _defs, _defs2, _defs3, _defs4, _defs5, _defs6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconServ01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\n\t\t.st0{clip-path:url(#SVGID_00000067202230882477967490000017402660457869946275_);fill:url(#SVGID_00000145765179136029043010000017399018915433815990_);}\n\t\n\t\t.st1{clip-path:url(#SVGID_00000065070259925385115580000000990306595616511373_);fill:url(#SVGID_00000057833222397351653520000002661657501575485098_);}\n\t\n\t\t.st2{clip-path:url(#SVGID_00000026852524259755327630000009785951749704557744_);fill:url(#SVGID_00000170278967353185318880000004213627123785550734_);}\n\t\n\t\t.st3{clip-path:url(#SVGID_00000160168811894008821290000012771190997099208346_);fill:url(#SVGID_00000079453239877281733870000012448547867357699980_);}\n\t\n\t\t.st4{clip-path:url(#SVGID_00000142879452469800455380000004454819310076379568_);fill:url(#SVGID_00000114065602688869071350000002530956926400192441_);}\n\t\n\t\t.st5{clip-path:url(#SVGID_00000150066211902208844310000005170922040921463949_);fill:url(#SVGID_00000089569456193736288760000013659360767875219090_);}\n\t\n\t\t.st6{clip-path:url(#SVGID_00000148635356359761596460000002329347183999607217_);fill:url(#SVGID_00000070798255815729684760000001202244269887847313_);}\n\t\n\t\t.st7{clip-path:url(#SVGID_00000115515643697651313960000011924532246186598575_);fill:url(#SVGID_00000037667105330715193860000013159065299512768696_);}\n\t\n\t\t.st8{clip-path:url(#SVGID_00000057115819617572794420000002674957941661403821_);fill:url(#SVGID_00000027583320377380301780000015754032134153633972_);}\n\t\n\t\t.st9{clip-path:url(#SVGID_00000009553401500413304410000006540787460126150792_);fill:url(#SVGID_00000127027881119645852350000009452633269273255046_);}\n\t\n\t\t.st10{clip-path:url(#SVGID_00000010272491871327288390000005322133264712692159_);fill:url(#SVGID_00000032619953127354637930000009506071060014524577_);}\n\t\n\t\t.st11{clip-path:url(#SVGID_00000022554061329755602200000009842001592122096263_);fill:url(#SVGID_00000088842517173331018000000011898602502821257659_);}\n\t\n\t\t.st12{clip-path:url(#SVGID_00000067924348881733560520000010626881239061124525_);fill:url(#SVGID_00000165195175643415806140000014064127460706491274_);}\n\t\n\t\t.st13{clip-path:url(#SVGID_00000106845826344924714500000006028169403215446404_);fill:url(#SVGID_00000067221307134731823140000010450789094275031961_);}\n\t\n\t\t.st14{clip-path:url(#SVGID_00000032647562125254502190000015972637783169325245_);fill:url(#SVGID_00000070841578707635576280000013487722707153776036_);}\n\t\n\t\t.st15{clip-path:url(#SVGID_00000171715350407335868780000005068413813657621399_);fill:url(#SVGID_00000095313852941510931660000010454710816676955316_);}\n\t\n\t\t.st16{clip-path:url(#SVGID_00000132771241514984310170000018005989382823890092_);fill:url(#SVGID_00000044171468050727066400000005575726357614314686_);}\n\t\n\t\t.st17{clip-path:url(#SVGID_00000029003810355436107940000015482380071220963723_);fill:url(#SVGID_00000078731092505618592810000012465664104702708408_);}\n\t\n\t\t.st18{clip-path:url(#SVGID_00000155133870107910695530000010417948792873590973_);fill:url(#SVGID_00000028316551393630753480000007994146914383136134_);}\n\t\n\t\t.st19{clip-path:url(#SVGID_00000150808601791349687610000015831908774803063205_);fill:url(#SVGID_00000014594086141312797630000010345010518091982468_);}\n\t\n\t\t.st20{clip-path:url(#SVGID_00000016044092019694511870000009439218972967626414_);fill:url(#SVGID_00000160167493315779872150000012247424927063315888_);}\n\t\n\t\t.st21{clip-path:url(#SVGID_00000134929999737935006250000002235938255510838715_);fill:url(#SVGID_00000057137002852017638970000008208238963009682570_);}\n\t\n\t\t.st22{clip-path:url(#SVGID_00000114769024681429355000000004949540022030477491_);fill:url(#SVGID_00000047061384826131034770000001034271700637094044_);}\n\t\n\t\t.st23{clip-path:url(#SVGID_00000042700300479634298360000006416568321075855285_);fill:url(#SVGID_00000047740113160614995540000001009934030506457738_);}\n\t\n\t\t.st24{clip-path:url(#SVGID_00000152963640600007811370000010793887516700074897_);fill:url(#SVGID_00000170997795861788923760000004018718048210072721_);}\n\t\n\t\t.st25{clip-path:url(#SVGID_00000055696695468018634930000000228657426732704132_);fill:url(#SVGID_00000013876317560864691100000015840477728680408973_);}\n\t\n\t\t.st26{clip-path:url(#SVGID_00000171685772067227335970000010857006331563358121_);fill:url(#SVGID_00000080900370399651966140000013241046659704693894_);}\n\t\n\t\t.st27{clip-path:url(#SVGID_00000036971023795318822320000012573276964188439485_);fill:url(#SVGID_00000119834152059571688790000002716907449263132563_);}\n\t\n\t\t.st28{clip-path:url(#SVGID_00000051381774258443162160000014914881672208473503_);fill:url(#SVGID_00000137811732724114329500000002432591698992531628_);}\n\t\n\t\t.st29{clip-path:url(#SVGID_00000132066418269794621450000003893967304072979606_);fill:url(#SVGID_00000086679080962551397970000007825596385556852663_);}\n\t\n\t\t.st30{clip-path:url(#SVGID_00000056401219461389934370000006000935925329150859_);fill:url(#SVGID_00000088092669336170684890000016652664127943909551_);}\n\t\n\t\t.st31{clip-path:url(#SVGID_00000016795357016140789150000006911208349722207134_);fill:url(#SVGID_00000170258807279114335980000006926735359595548584_);}\n\t\n\t\t.st32{clip-path:url(#SVGID_00000172438757121530606630000011269665652944816276_);fill:url(#SVGID_00000106149073569443415450000012515724225354347182_);}\n\t\n\t\t.st33{clip-path:url(#SVGID_00000080202138119884932750000006669558675884341689_);fill:url(#SVGID_00000026874178975921205290000005346746255631329449_);}\n\t\n\t\t.st34{clip-path:url(#SVGID_00000134951984181364141890000000397534518450175382_);fill:url(#SVGID_00000054965224879218697490000016228588285078843053_);}\n\t\n\t\t.st35{clip-path:url(#SVGID_00000041993484099345979480000006069755758517121433_);fill:url(#SVGID_00000033352520412554632150000007615662747492277438_);}\n\t\n\t\t.st36{clip-path:url(#SVGID_00000181082473884950067360000003252537196468950659_);fill:url(#SVGID_00000065773479933578016680000001177812782064128145_);}\n\t\n\t\t.st37{clip-path:url(#SVGID_00000094613856244917790830000007526975904632736922_);fill:url(#SVGID_00000144306299253870561990000000746379797334948250_);}\n\t\n\t\t.st38{clip-path:url(#SVGID_00000092425429653931430060000001473086054537360797_);fill:url(#SVGID_00000102525042222937944230000009361204219045679232_);}\n\t\n\t\t.st39{clip-path:url(#SVGID_00000084523822675650746080000014627417298460169100_);fill:url(#SVGID_00000101801791241904467940000018116825225740959620_);}\n\t\n\t\t.st40{clip-path:url(#SVGID_00000136404263407179336230000010398160499948504747_);fill:url(#SVGID_00000093890415803697440480000000162387867305229977_);}\n\t\n\t\t.st41{clip-path:url(#SVGID_00000071544878399985094210000012764649808591221182_);fill:url(#SVGID_00000142871404759929174400000015226327958746297017_);}\n\t\n\t\t.st42{clip-path:url(#SVGID_00000057847199892552942040000006976908440924267395_);fill:url(#SVGID_00000029748874844721127490000001670783043044352648_);}\n\t\n\t\t.st43{clip-path:url(#SVGID_00000042716995627894903750000009304732508341709758_);fill:url(#SVGID_00000122695298210194359580000015876879782375143836_);}\n\t\n\t\t.st44{clip-path:url(#SVGID_00000019671533209279220720000015800298537155103121_);fill:url(#SVGID_00000044892009130655898970000005065543510856801462_);}\n\t\n\t\t.st45{clip-path:url(#SVGID_00000098216585519954979460000001368083895124471950_);fill:url(#SVGID_00000123426999588119901180000004220600441098237618_);}\n\t\n\t\t.st46{clip-path:url(#SVGID_00000076599046062183525220000006715117600856789159_);fill:url(#SVGID_00000078756369287047701990000011727849924250252939_);}\n\t\n\t\t.st47{clip-path:url(#SVGID_00000143614711267444128550000006171333545595283852_);fill:url(#SVGID_00000033336949339705474460000002044088778583122110_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000127039681620981257590000001082417658462398093_",
    d: "M43.6,26.1c0.3-0.9,0.3-0.9,1-0.4c0.4,0.3,0.8,0.5,1,1 c0,0.2,0,0.3-0.2,0.3c-0.3,0-0.6,0-0.8,0c-0.1,0-0.2,0-0.3,0C43.3,27,43.3,27,43.6,26.1 M4.3,27.6c0-0.5,0-1,0-1.5 c0-0.5,0-0.9,0-1.4c0-0.3,0.1-0.3,0.4-0.3c0.4,0.1,0.7,0.3,0.7,0.7c0,0.8,0,1.7,0,2.5c0,0.2-0.1,0.3-0.3,0.3c-0.2,0-0.3,0-0.5,0 c0,0,0,0-0.1,0C4.4,27.9,4.3,27.8,4.3,27.6 M5.5,22.7c0-1.5,0-3,0-4.5c0-0.3,0.1-0.4,0.4-0.4c2.1,0,4.2,0,6.4,0 c0.3,0,0.4,0.1,0.4,0.4c0,1.5,0,3,0,4.5c0,0.3-0.1,0.4-0.4,0.4c-1.1,0-2.1,0-3.2,0c-1.1,0-2.1,0-3.2,0c0,0,0,0,0,0 C5.6,23.1,5.5,23,5.5,22.7 M28.8,17.8c0.3,0,0.4,0.1,0.4,0.4c0,1.5,0,3,0,4.5c0,0.3-0.1,0.4-0.4,0.4c-1.1,0-2.1,0-3.2,0 c-1,0-2.1,0-3.2,0c-0.3,0-0.4-0.1-0.4-0.4c0-1.5,0-3,0-4.5c0-0.3,0.1-0.4,0.4-0.4c1.1,0,2.2,0,3.2,0 C26.7,17.8,27.8,17.8,28.8,17.8 M14.5,22.7c0-1.5,0-3,0-4.5c0-0.3,0.1-0.4,0.4-0.4c0.8,0,1.6,0,2.5,0c0.8,0,1.6,0,2.4,0 c0.3,0,0.4,0.1,0.4,0.4c0,1.5,0,3,0,4.5c0,0.3-0.1,0.4-0.4,0.4c-1.6,0-3.2,0-4.9,0c0,0,0,0,0,0C14.6,23.1,14.5,23,14.5,22.7  M4.1,15.5c-0.5,1.2-0.7,2.4-0.8,3.6c-0.3,3.2-0.1,6.3-0.2,9.5C3.1,29,3.2,29,3.5,29c1.5,0,3,0,4.5,0c0.2,0,0.4-0.1,0.6-0.2 c1.3-0.7,2.5-0.7,3.8,0c0.2,0.1,0.4,0.2,0.6,0.2c5.9,0,11.8,0,17.7,0c0.4,0,0.4-0.1,0.4-0.5c0-0.6,0-1.3,0-1.9c0-2.8,0-5.6,0-8.4 c0-0.4,0.1-0.5,0.5-0.5c0.4,0,0.8,0,1.2,0c0.4,0,0.8,0,1.3,0c0.9,0,1.7,0.4,2.3,1.1c0.3,0.3,0.7,0.7,1,1c0.9,1,1.9,2,2.8,3 c0.2,0.2,0.3,0.5,0.2,0.8c-0.1,0.3-0.3,0.4-0.6,0.4c-1.5,0-3,0.2-4.4-0.4c-0.8-0.3-1.7-0.5-2.6-0.7c-0.3,0-0.4,0-0.4,0.3 c0,1.7,0,3.4,0,5.1c0,0.3,0.1,0.4,0.4,0.4c1.6,0,3.2,0,4.9,0c0.2,0,0.4-0.1,0.6-0.2c1.1-0.6,2.3-0.7,3.4-0.1 c0.4,0.2,0.6,0.2,0.9-0.1c0.6-0.5,1.3-0.7,2.1-0.6c0.4,0,0.8,0,1.2,0c0.3,0,0.5,0,0.8,0c0.3,0,0.3-0.1,0.3-0.3 c0-1.3-0.5-2.3-1.6-3c-1-0.6-1.9-1.1-2.9-1.7c-0.3-0.2-0.6-0.4-0.8-0.6c-1.6-1.7-3.1-3.3-4.7-4.9c-1-1.1-2.2-1.9-3.7-2.2 c-0.8-0.2-1.7-0.2-2.5-0.2c-4.2,0-8.4,0-12.5,0v0c-4.4,0-8.8,0-13.3,0c0,0,0,0,0,0C4.5,15,4.3,15.2,4.1,15.5"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090285334783340964960000009861982468636734132_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.013,
    y1: 35.1235,
    x2: 25.013,
    y2: 15.5587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000127039681620981257590000001082417658462398093_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000090285334783340964960000009861982468636734132_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000049180778701303726730000004529572730525284007_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000127039681620981257590000001082417658462398093_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000110442731961727145220000017081420755477783476_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.9716,
    y1: 35.1235,
    x2: 24.9716,
    y2: 15.5587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 15,
    style: {
      clipPath: "url(#SVGID_00000049180778701303726730000004529572730525284007_)",
      fill: "url(#SVGID_00000110442731961727145220000017081420755477783476_)"
    },
    width: 43.9,
    height: 14
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000050646625920112588030000016925347594992780937_",
    d: "M13.8,30.3c0.3,0.6,0.5,1.2,0.5,1.8 c0,0.4,0.1,0.5,0.5,0.5c4.9,0,9.7,0,14.6,0c2.2,0,4.3,0,6.5,0c0,0,0.1,0,0.1,0c0.1,0,0.3,0,0.3-0.2c0-0.8,0.2-1.4,0.5-2.2H13.8z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000040570507675086050740000008616856109220471478_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.26,
    y1: 35.1235,
    x2: 25.26,
    y2: 15.5587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000050646625920112588030000016925347594992780937_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000040570507675086050740000008616856109220471478_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000144322278672116766330000006343466194607493001_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000050646625920112588030000016925347594992780937_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044861276591084085440000010366426939439549825_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.26,
    y1: 35.1235,
    x2: 25.26,
    y2: 15.5587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 13.8,
    y: 30.3,
    style: {
      clipPath: "url(#SVGID_00000144322278672116766330000006343466194607493001_)",
      fill: "url(#SVGID_00000044861276591084085440000010366426939439549825_)"
    },
    width: 23,
    height: 2.4
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000148620313577860779830000006389017090812605314_",
    d: "M38.8,32.2c0-0.7,0.5-1.3,1.2-1.3 c0.7,0,1.3,0.6,1.3,1.3c0,0.7-0.6,1.3-1.2,1.3c0,0,0,0,0,0C39.4,33.5,38.8,32.9,38.8,32.2 M37.4,32.2c0,1.5,1.2,2.8,2.7,2.8 c1.5,0,2.7-1.2,2.8-2.7c0-1.5-1.2-2.8-2.7-2.8c0,0,0,0,0,0C38.6,29.5,37.4,30.7,37.4,32.2"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000037665471412758268540000006189823811829445532_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.0874,
    y1: 35.1235,
    x2: 40.0874,
    y2: 15.5587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000148620313577860779830000006389017090812605314_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000037665471412758268540000006189823811829445532_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000120532711435545517080000002447105846962789001_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000148620313577860779830000006389017090812605314_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085249406145224157860000012209374276356242089_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.0951,
    y1: 35.1235,
    x2: 40.0951,
    y2: 15.5587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 37.4,
    y: 29.5,
    style: {
      clipPath: "url(#SVGID_00000120532711435545517080000002447105846962789001_)",
      fill: "url(#SVGID_00000085249406145224157860000012209374276356242089_)"
    },
    width: 5.5,
    height: 5.5
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000133490875671105979590000014623037795851107498_",
    d: "M10.4,33.5c-0.7,0-1.3-0.6-1.3-1.3 c0-0.7,0.6-1.3,1.2-1.3c0.7,0,1.3,0.6,1.3,1.3C11.7,32.9,11.1,33.5,10.4,33.5C10.4,33.5,10.4,33.5,10.4,33.5 M10.4,29.5 c-1.5,0-2.7,1.2-2.7,2.8c0,1.5,1.2,2.7,2.7,2.7c1.5,0,2.7-1.2,2.7-2.8C13.1,30.7,11.9,29.5,10.4,29.5 C10.4,29.5,10.4,29.5,10.4,29.5"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179611465038061137820000003818409857474799490_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.436,
    y1: 35.1235,
    x2: 10.436,
    y2: 15.5587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000133490875671105979590000014623037795851107498_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000179611465038061137820000003818409857474799490_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065033728313463333980000014612206388146155962_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000133490875671105979590000014623037795851107498_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119075770819858892140000010180907684109375412_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.4406,
    y1: 35.1235,
    x2: 10.4406,
    y2: 15.5587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 7.7,
    y: 29.5,
    style: {
      clipPath: "url(#SVGID_00000065033728313463333980000014612206388146155962_)",
      fill: "url(#SVGID_00000119075770819858892140000010180907684109375412_)"
    },
    width: 5.4,
    height: 5.5
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000053510203213610093620000008568495674538896308_",
    d: "M43.3,29.6c-0.2,0.1-0.3,0.2-0.1,0.5 c0.5,0.7,0.7,1.5,0.7,2.3c0,0.2,0,0.3,0.3,0.3c0.3,0,0.5,0,0.8,0c0.3,0,0.7,0,1,0c0.8,0,1.4-0.6,1.4-1.4c0-0.5,0-1.1,0-1.6 c0-0.3-0.1-0.4-0.4-0.4c-0.5,0-1,0-1.5,0c-0.4,0-0.8,0-1.2,0c0,0-0.1,0-0.1,0C43.9,29.3,43.6,29.4,43.3,29.6"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000113352283982806447340000016105983738584692893_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.3179,
    y1: 35.1235,
    x2: 45.3179,
    y2: 15.5587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000053510203213610093620000008568495674538896308_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000113352283982806447340000016105983738584692893_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000077291546457493274740000008146390814384267931_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000053510203213610093620000008568495674538896308_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070083725445113667490000006008497041440983958_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.288,
    y1: 35.1235,
    x2: 45.288,
    y2: 15.5587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 43.1,
    y: 29.3,
    style: {
      clipPath: "url(#SVGID_00000077291546457493274740000008146390814384267931_)",
      fill: "url(#SVGID_00000070083725445113667490000006008497041440983958_)"
    },
    width: 4.4,
    height: 3.4
  })), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000071548113993096342250000005846984193036324228_",
    d: "M3.4,30.3c-0.9,0-0.9,0-0.9,0.9c0,0.8,0.5,1.4,1.3,1.4 c0.6,0,1.2,0,1.7,0c0.3,0,0.6,0,0.9,0c0.2,0,0.3,0,0.3-0.2c-0.1-0.7,0.1-1.4,0.5-2.1C5.8,30.3,4.6,30.3,3.4,30.3"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008831154558733299080000003960436650763145377_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.8085,
    y1: 35.1235,
    x2: 4.8085,
    y2: 15.5587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000071548113993096342250000005846984193036324228_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000008831154558733299080000003960436650763145377_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000008828037166216862340000009202518535348239795_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000071548113993096342250000005846984193036324228_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057145867056305873000000017192713142123001761_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.7909,
    y1: 35.1235,
    x2: 4.7909,
    y2: 15.5587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA780C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6373,
    style: {
      stopColor: "#D2B34B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E5D06A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 30.3,
    style: {
      clipPath: "url(#SVGID_00000008828037166216862340000009202518535348239795_)",
      fill: "url(#SVGID_00000057145867056305873000000017192713142123001761_)"
    },
    width: 4.7,
    height: 2.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconServ01);
export default __webpack_public_path__ + "static/media/IconServ-01.acf97d6154e70a993d8ce96f52b63b08.svg";
export { ForwardRef as ReactComponent };